<template>
  <div class="d-flex py-2">
    <icon
      size="56"
      :icon="icon"
      class="icon mr-4 flex-shrink-0"
    />
    <ul class="mb-6">
      <li
        v-for="(line, i) in clearedPreviewItem"
        :key="i"
        :class="{'error--text': line.error}"
      >
        <p>
          <template
            v-if="line.prepend"
          >
            <span v-html="line.prepend" />
          </template>
          <strong>
            &nbsp;
            <u>
              <template v-if="line.value !== null">{{ line.model || line.value }}</template>
              <span
                v-else
                class="error--text"
              >N/A</span>
            </u>
          </strong>
          <template v-if="line.append">&nbsp;<span v-html="line.append" /></template>
        </p>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'subform-preview',
  props: {
    previewList: {
      type: Array,
      required: true,
    },
    icon: {
      type: String,
      default: 'mdi-car',
    },
  },
  computed: {
    clearedPreviewItem () {
      return this.previewList.filter(item => item);
    },
  },
};
</script>

<style lang="scss" scoped>
.icon {
  color: var(--v-primary-base, $clr-primary);
}
</style>
